import React from 'react';
import DashboardPrototype from '../components/reports/DashboardPrototype';

const Prototypes: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-gray-800 rounded-lg border border-gray-700 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white">Data Visualization Prototypes</h1>
            <p className="text-gray-400 mt-2">
              Rapid prototyping environment for testing chart designs and data visualizations
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <span className="bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-medium">
              🔥 Hot-Swap Ready
            </span>
          </div>
        </div>
      </div>

      {/* Prototype Dashboard */}
      <DashboardPrototype />
    </div>
  );
};

export default Prototypes;
